import React, { useEffect, useMemo } from 'react'

import OfferMapContainer from '../OfferMap'
import Spacing from 'components/Common/Spacing'
import { FLASH_OFFERS_TYPES } from 'constants/offerList'
import Heading from 'components/Luxkit/Typography/Heading'
import { useAppSelector } from 'hooks/reduxHooks'
import useOfferList from 'hooks/Offers/useOfferList'
import { fetchOffersById } from 'actions/OfferActions'

interface Props {
  filters: App.OfferListFilters;
  markers: Array<App.MapMarker>;
  title: string;
  hash: string;
  key: string;
  withMap: boolean;
}

function DiscoverGuideMap(props: Props) {
  const offerList = useOfferList({
    ...props.filters,
    offerTypes: FLASH_OFFERS_TYPES,
  })

  const offerState = useAppSelector(state => state.offer.offers)

  useEffect(() => {
    fetchOffersById(offerList.offerIds)
  }, [offerList.offerIds])
  const offers = useMemo(() => {
    return offerList.offerIds.map(id => offerState[id]).filter(Boolean)
  }, [offerList.offerIds, offerState])

  if (offerList.fetching || offerList.offerIds.length === 0) {
    return null
  }

  return <Spacing mt={40} id={props.hash}>
    <Heading variant="heading3" as="h2" align="center">{props.title}</Heading>
    <Spacing mt={40}>
      {props.withMap && <OfferMapContainer
        filters={props.filters}
        markers={props.markers}
        offers={offers}
        loaded={!offerList.fetching}
      />}
    </Spacing>
  </Spacing>
}

export default DiscoverGuideMap
